/** Axis scales shared by the chart renderers. */

/** Picks a readable Y scale: 1/2/5 × 10^n steps with about five ticks. */
export const niceScale = (max: number, targetTicks = 5): { max: number; step: number } => {
    if (max <= 0) return { max: 4, step: 1 };
    const raw = max / targetTicks;
    const magnitude = 10 ** Math.floor(Math.log10(raw));
    const step = Math.max(1, [1, 2, 5, 10].map((m) => m * magnitude).find((s) => s >= raw) ?? raw);
    return { max: Math.ceil(max / step) * step, step };
};

const ALIGNED_STEPS = [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];

/**
 * Scale with a fixed number of intervals, so two axes (e.g. the combo graph's left and right
 * axes) share the same grid lines. Uses a finer set of "nice" steps than `niceScale` to avoid
 * wasting vertical space, and keeps steps whole numbers (the data are counts).
 */
export const alignedScale = (max: number, intervals: number): { max: number; step: number } => {
    if (max <= 0) return { max: intervals, step: 1 };
    const raw = max / intervals;
    const magnitude = 10 ** Math.floor(Math.log10(raw));
    const step =
        ALIGNED_STEPS.map((m) => Math.round(m * magnitude * 1e6) / 1e6).find(
            (s) => s >= raw - 1e-9 && Number.isInteger(s),
        ) ?? Math.ceil(raw);
    return { max: step * intervals, step: Math.max(1, step) };
};
